export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_EXT_DATA_CATEGORY = "SET_EXT_DATA_CATEGORY";


export const GET_EXT_DATA_CATEGORIES = "GET_EXT_DATA_CATEGORIES";
export const GET_EXT_DATA_CATEGORIES_SUCCESS = "GET_EXT_DATA_CATEGORIES_SUCCESS";
export const GET_EXT_DATA_CATEGORIES_FAILURE = "GET_EXT_DATA_CATEGORIES_FAILURE";

export const GET_EXT_DATA_CATEGORY = "GET_EXT_DATA_CATEGORY";
export const GET_EXT_DATA_CATEGORY_SUCCESS = "GET_EXT_DATA_CATEGORY_SUCCESS";
export const GET_EXT_DATA_CATEGORY_FAILURE = "GET_EXT_DATA_CATEGORY_FAILURE";

export const CREATE_EXT_DATA_CATEGORY = "CREATE_EXT_DATA_CATEGORY";
export const CREATE_EXT_DATA_CATEGORY_SUCCESS = "CREATE_EXT_DATA_CATEGORY_SUCCESS";
export const CREATE_EXT_DATA_CATEGORY_FAILURE = "CREATE_EXT_DATA_CATEGORY_FAILURE";

export const UPDATE_EXT_DATA_CATEGORY = "UPDATE_EXT_DATA_CATEGORY";
export const UPDATE_EXT_DATA_CATEGORY_SUCCESS = "UPDATE_EXT_DATA_CATEGORY_SUCCESS";
export const UPDATE_EXT_DATA_CATEGORY_FAILURE = "UPDATE_EXT_DATA_CATEGORY_FAILURE";

export const DELETE_EXT_DATA_CATEGORY = "DELETE_EXT_DATA_CATEGORY";
export const DELETE_EXT_DATA_CATEGORY_SUCCESS = "DELETE_EXT_DATA_CATEGORY_SUCCESS";
export const DELETE_EXT_DATA_CATEGORY_FAILURE = "DELETE_EXT_DATA_CATEGORY_FAILURE";

export const UPDATE_EXT_DATA_CATEGORIES_ORDER = "UPDATE_EXT_DATA_CATEGORIES_ORDER";
export const UPDATE_EXT_DATA_CATEGORIES_ORDER_SUCCESS = "UPDATE_EXT_DATA_CATEGORIES_ORDER_SUCCESS";
export const UPDATE_EXT_DATA_CATEGORIES_ORDER_FAILURE = "UPDATE_EXT_DATA_CATEGORIES_ORDER_FAILURE";